export function setupCalendar(triggerSelector = '[data-action*="anchor"], a[href^="#"]:not([href="#"]):not([role="tab"]):not([data-action*="accordion"])') {
    const checkPikaday = setInterval(function () {
        if (typeof Pikaday != 'undefined') {
            clearInterval(checkPikaday);
            createCalendar();
        }
    }, 10);

    const documentLanguage = document.documentElement.lang;
    const pikadayLabels = [];

    pikadayLabels['en-GB'] = {
        previousMonth: 'Previous month',
        nextMonth: 'Next month',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    };
    pikadayLabels['da-DK'] = {
        previousMonth: 'Forrige måned',
        nextMonth: 'Næste måned',
        months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec'],
        weekdays: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
        weekdaysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør']
    };

    const createCalendar = () => {

        const eventItems = Array.from(document.querySelectorAll('.calendar-v2 .item'));
        const eventDates = [];
        const container = document.querySelector('.datepicker');

        container.classList.add('testing')

        function filterItems(date) {
            eventItems.forEach(eventItem => {
                const eventDate = new Date(eventItem.getAttribute('data-date'));

                if (
                    eventDate.getFullYear() == date.getFullYear() &&
                    eventDate.getMonth() == date.getMonth() &&
                    eventDate.getDate() == date.getDate()
                ) {
                    eventItem.classList.remove('js-hide');
                } else {
                    eventItem.classList.add('js-hide');
                }
            });
        }

        eventItems.forEach(eventItem => {
            const eventDate = eventItem.getAttribute('data-date');
            eventDates.push(eventDate);
        });

        const startDate = new Date();

        const picker = new Pikaday({
            events: eventDates,
            firstDay: 1,
            i18n: pikadayLabels[documentLanguage],
            minDate: new Date(),
            onSelect: function (date) {
                filterItems(date);
            }
        });

        picker.setDate(startDate);

        container.appendChild(picker.el);
    };
}